import React from 'react'

function ServiceDesk(){
    return(
        <div className="sub_page_wrapper page_content">
            <h3>Service Desk Management</h3>

            <p>
            Smart KS has experience in the scoping, set up, deployment and management of
service desks. The solution can be tailored to both the public and private sector.
This will be accomplished using ITIL framework guideline of service management.
This will ensure that the operations are managed within the stipulated service
levels.
            </p>

            <p>
            To ensure minimum disruption in operations, Smart KS will employ remote desk
technology to assist users with IT problem at the quickest possible time. Smart KS
will also deploy experienced technicians on site to resolve the complex problems
that cannot be resolved remotely. 
            </p>

            <p>
            We make use of the latest and sophisticated service desk software that allow for
the end-to-end tracking of tickets logged and flagging of outstanding or out of SLA
tickets. We will also provide detailed management reports to depict service
interruptions in the network. These will be used to enhance the network and
operational systems. 
            </p>


        </div>
    );        
    
}

export default ServiceDesk;